import React from 'react';
import './mortgage-karj.css';

const MortgageKarj = () => {
  return (
    <div className="mortgage-loan-container">
    <div className="banner">
      <img src="/images/slider1.jpg" alt="Banner" className="banner" />
    </div>
      <h1>मॉर्गेज तारण कर्ज</h1>
      <p>
        <strong>श्री वरद विनायक मॉर्गेज लोन</strong> ची सर्वात चांगली गोष्ट म्हणजे त्याचे <strong>जलद विवरण</strong>, 
        <strong>किमान कागदपत्रे</strong> आणि <strong>सोपे व्यवहार</strong> — जे इतर कर्ज पर्यायांच्या बाबतीत नाहीत.
      </p>

      <h1>आवश्यक कागदपत्रे:</h1>
      <ul>
        <li>मालमत्तेचा सर्च रिपोर्ट</li>
        <li>मालमत्तेचा मूल्यांकन रिपोर्ट</li>
        <li>500 रुपये चे दोन स्टॅम्प पेपर</li>
        <li>मालमत्तेचे गहान खत (मोर्गेज)</li>
        <li>इतर संस्थेची (NOC)</li>
        <li>पोस्टाचे 4 तिकीट</li>
        <li>15 चेक</li>
        <li>2 फोटो</li>
        <li>दोन जामीनदार व त्यांचे आधार कार्ड (झेरॉक्स)</li>
      </ul>
    </div>
  );
};

export default MortgageKarj;
